/** @jsxImportSource theme-ui */
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Seo, { SeoInterface } from "./Common/Seo";

interface LayoutProps {
  children?: React.ReactNode | React.ReactNode[];
  headerTheme: "BLUE" | "CREAM";
  alt?: boolean;
  seo?: SeoInterface;
  headerContainer?: "wide" | "full";
  className?: string;
}

const Layout = ({
  children,
  headerTheme,
  alt,
  seo,
  headerContainer,
  className,
}: LayoutProps) => {
  return (
    <div
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
      className={className}
    >
      <Seo seo={seo} />
      <Header theme={headerTheme} alt={alt} container={headerContainer} />
      {children}
      <Footer container={headerContainer} />
    </div>
  );
};

export default Layout;
